import React from "react";
import Skeleton from "@mui/material/Skeleton";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

const InputSkeleton = () => (
  <Skeleton variant="rectangular" height={40} sx={{ borderRadius: "16px" }} />
);

const BigButtonSkeleton = () => (
  <Box sx={{ aspectRatio: "5/4" }}>
    <Skeleton variant="rectangular" width="100%" height="100%" sx={{ borderRadius: "16px" }} />
  </Box>
);

export default function CaptureSkeleton() {
  return (
    <Box>
      <Card>
        <CardContent>
          <Box sx={{ mt: -1, mb: 1 }}>
            <Skeleton variant="text" width={100} height={30} />
          </Box>
          <Grid container alignItems="flex-start" spacing={1}>
            <Grid size={{ md: 6, xs: 12 }}>
              <BigButtonSkeleton />
            </Grid>
            <Grid size={{ md: 6, xs: 12 }}>
              <Grid container spacing={1}>
                <Grid size={6}>
                  <InputSkeleton />
                </Grid>
                <Grid size={6}>
                  <InputSkeleton />
                </Grid>
                <Grid size={6}>
                  <InputSkeleton />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Box sx={{ mt: 2 }}>
        <Card>
          <CardContent>
            <Box sx={{ mt: -1, mb: 1 }}>
              <Skeleton variant="text" width={100} height={30} />
            </Box>
            <Grid container alignItems="flex-start" spacing={1}>
              {Array.from({ length: 10 }).map((_, index) => (
                <Grid key={index} size={{ xs: 12, md: 4 }}>
                  <InputSkeleton />
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}
